( function( $ ) {
  $( document ).on( 'click', '.snf-send-form', function( event ) {
    event.preventDefault();

    var formData = $( this ).parents( '.send-newsletter-form' ),
        response;

    if ( formData.valid() && !$( this ).hasClass( 'button-loading' ) ) {
      $.ajax({
        url: 'newsletter/newsletter/gerador-de-newsletter.php',
        type: 'POST',
        data: formData.serialize(),
        beforeSend: function() {
          $( '.snf-send-form' ).addClass( 'button-loading' ).attr( 'disabled', true );
        }
      })
      .done(function(data) {
        response = $.parseJSON(data);

        if ( response ) {
          swal( "", "Você foi cadastrado com sucesso em nosso boletim informativo.", "success" );
        }
        else {
          swal( "", "Ocorreu um erro ao realizar seu cadastro. Por favor tente novamente.", "error" );
        }

        $( '.snf-send-form' ).removeClass( 'button-loading' ).attr( 'disabled', false );
        formData[0].reset();
      })
      .fail(function(data) {
        response = $.parseJSON(data);

        if ( response ) {
          swal( "", "Você foi cadastrado com sucesso em nosso boletim informativo.", "success" );
        }
        else {
          swal( "", "Ocorreu um erro ao realizar seu cadastro. Por favor tente novamente.", "error" );
        }

        $( '.snf-send-form' ).removeClass( 'button-loading' ).attr( 'disabled', false );
      });
    }
    else {
      if ( $( '.error' ).parent().find( 'span' ).length == 0 )
        $( '.error' ).parent().append( $( "<span></span>" ).addClass( 'invalid' ) );

      return false;
    }
  });
})( jQuery );